var Model = require('Model'),
    $     = require("jquery");

var LayerObject = Model.extend({

    options: {},

    initialize: function(id, fields, options){
        var that = this,
            bbox;

        options || (options = {});

        if(id === undefined){
            throw new Error('Id is required')
        }

        that.id = parseInt(id);

        that._bbox = null;

        that._geometry = null;

        if($.isPlainObject(options['bbox'])){
            bbox = options['bbox'];
            if('sw' in bbox && 'ne' in bbox){
                that.setBBox(bbox['sw'], bbox['ne']);
            }
            delete options['bbox'];
        }

        if($.isPlainObject(options['geom'])){
            that.setGeometry(options['geom']);
            delete options['geom'];
        }

        LayerObject.__super__.initialize.call(that, fields, options);
    },

    fget: function(attribute){
        var that = this;
        if("#"+attribute in that._attributes){
            return that.get("#"+attribute);
        }
        return that.get(attribute)
    },

    getId: function(){
        return this.id
    },

    getGeometry: function(){
        return this._geometry;
    },

    setGeometry: function(geometry){
        this._geometry = geometry;
        return this;
    },

    getBBox: function(){
        return this._bbox;
    },

    setBBox: function(sw, ne){
        var that = this;
        if($.isArray(sw) && $.isArray(ne)){
            that._bbox = {
                sw: sw,
                ne: ne
            };
        }
        return that;
    }
});

module.exports = LayerObject;


//////////////////
// WEBPACK FOOTER
// ./src/Project/LayerObject.js
// module id = 17
// module chunks = 0